import { lang } from '@umu/ukit-lang';
/**
 * @description
 */

import './sectionRadioboxResultList.scss';

import React, { Component } from 'react';
import { getPollQuestionContentList } from '@umu/umu-api';
import { EOptionType, PollType } from '@umu/umu-types';
import { ISectionOptionResultContent, ISurveySectionInfo, IPageInfo, ISectionOptionResultInfo } from '@umu/umu-types';

import { components } from 'common';
const { Portal, Loading } = components;

import PagePanel from '../../../../@pagePanel/pagePanel';
import SectionResultItemHeader from '../../../@sectionResultItemHeader/sectionResultItemHeader';
import FormTextareaResultList from '../@formTextareaResultList/formTextareaResultList';
import FormRadioboxResultList from '../@formRadioboxResultList/formRadioboxResultList';

interface IProps {
    sectionInfo: ISurveySectionInfo;
    parentId?: number;
    objId?: number;
}

interface IState {
    showPanel: boolean;
    loading: boolean;
    panelData: {
        list: ISectionOptionResultContent[];
        page_info: IPageInfo;
    };
}

export default class SectionRdioboxResultList extends Component<IProps, IState> {
    constructor(props: IProps, state: IState) {
        super(props, state);

        this.state = Object.assign({}, this.state, {
            showPanel: false,
            panelData: {
                list: [],
                page_info: {},
            },
        });
    }

    public getOptionOther = () => {
        const { resultList = [] } = this.props.sectionInfo;
        const optionOther = resultList.filter((item) => {
            return item.type === EOptionType.OTHER;
        })[0] as ISectionOptionResultInfo;
        return optionOther;
    };

    public renderOptionOtherTip() {
        const optionOther = this.getOptionOther();
        const optionCount = optionOther.count;
        const contentTotal = optionOther.other_content_count || 0;
        const otherCount = optionCount - contentTotal;
        if (otherCount === 0) {
            return null;
        }
        return (
            <div className="option-extra-value-stat">
                {lang('有{$0}位学员选择了该选项，但未输入文字。', otherCount)}
            </div>
        );
    }

    public render() {
        return (
            <div className="section-result-item-body">
                {this.renderFormResult()}
                {this.renderMoreAction()}
                {this.renderMorePanel()}
            </div>
        );
    }

    /**
     * @override
     */
    public renderFormResult() {
        const { resultList } = this.props.sectionInfo;
        return <FormRadioboxResultList resultList={resultList as ISectionOptionResultInfo[]} />;
    }

    /**
     * @override
     */
    public renderMoreAction() {
        const optionOther = this.getOptionOther();

        // 是否有 其它 选项
        if (!optionOther) {
            return null;
        }

        // 是否有填写内容
        const contentList = optionOther.other_content || [];
        const contentTotal = optionOther.other_content_count || 0;
        if (contentList.length === 0) {
            return this.renderOptionOtherTip();
        }

        const actionLabel = lang('更多 >');

        return (
            <div className="option-extra-value-list">
                <FormTextareaResultList resultList={contentList as ISectionOptionResultContent[]} />
                {this.renderOptionOtherTip()}
                {contentTotal > contentList.length ? (
                    <div className="section-textarea-result-more">
                        <div className="action" onClick={this.onShow}>
                            {actionLabel}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    public onShow = () => {
        this.setState({
            showPanel: true,
        });
        this.loadPanelData();
    };

    public onBack = () => {
        this.setState({
            showPanel: false,
        });
    };

    public loadMore = () => {
        this.loadPanelData();
    };

    public loadPanelData = () => {
        if (this.state.loading) {
            return;
        }

        const { parentId, objId } = this.props;
        if (!parentId || !objId) {
            return;
        }

        const { page_info } = this.state.panelData;
        if (page_info.current_page && page_info.current_page >= page_info.total_page_num) {
            return;
        }

        this.setState({
            loading: true,
        });

        getPollQuestionContentList({
            parent_id: parentId,
            parent_type: PollType.HOMEWORK_EVAL_POLL,
            obj_id: objId,
            question_id: this.props.sectionInfo.id,
            page: (page_info.current_page || 0) + 1,
            size: 20,
        }).then((ret) => {
            if (ret.error_code) {
                return;
            }
            const panelData = Object.assign({}, this.state.panelData);
            panelData.list = panelData.list.concat(ret.data.list);
            panelData.page_info = ret.data.page_info;
            this.setState({
                panelData,
                loading: false,
            });
        });
    };

    public renderMorePanel() {
        if (!this.state.showPanel) {
            return null;
        }

        const { sectionInfo } = this.props;
        return (
            <Portal preventBodyScroll={true}>
                <PagePanel
                    clsName={'section-more-panel-holder'}
                    title={lang('查看问题')}
                    leftTitle="<i class='icon icon-arrow arrow1 gray left'>"
                    leftCallback={this.onBack}
                    rightTitle=""
                    hitBottomCallback={this.loadMore}
                >
                    <div className="section-more-panel">
                        <div className="section-more-panel-header">
                            <SectionResultItemHeader sectionInfo={sectionInfo} />
                        </div>
                        <div className="section-more-panel-body">{this.renderSectionMoreBody()}</div>
                    </div>
                </PagePanel>
            </Portal>
        );
    }

    /**
     * @override
     */
    public renderSectionMoreBody() {
        const { resultList } = this.props.sectionInfo;
        const renderList = this.state.panelData.list;
        return (
            <>
                <FormRadioboxResultList resultList={resultList as ISectionOptionResultInfo[]} />
                <FormTextareaResultList resultList={renderList} />
                {this.state.loading ? <Loading /> : null}
                {this.renderOptionOtherTip()}
            </>
        );
    }
}
